// extracted by mini-css-extract-plugin
export default {"parent-mode":"children-settings_parent-mode__4J1KG","label":"children-settings_label__h4E2O"};